export enum PVSProvider {
    DOC_CIRRUS = 'doc-cirrus',
    DATA_CUR = 'data-cur',
    TIGRAIS = 'tigrais',
}
